<template>
  <div class="d-flex justify-content-left">
    <div class="text-success" v-if="data.data">
      <font-awesome-icon icon="check-circle" />
    </div>
    <div class="text-danger" v-else>
      <font-awesome-icon icon="times-circle" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>
